
import { Injectable, OnInit } from '@angular/core';
import { RequestService } from './request.service';
import { IResponseGetCustomerListTessere } from '../models/response'

@Injectable()
export class CardService implements OnInit {

    constructor(
        protected _requestService: RequestService
    ) {

    }

    ngOnInit() {

    }
    ReprintCard(name: string, surname: string, email: string) {
        return new Promise((resolve, reject) => {
            this._requestService.makeRequest('rest/internal/action/reprintCard',
                {
                    "user": {
                        "name": name,
                        "surname": surname,
                        "email": email
                    }, "typeRequest": 'reprintCard'
                },
                (data) => {
                    resolve(data.message);
                }, (error) => {
                    reject({ type: "SERVER", content: error.statusText })
                },
                null,
                false,
                null)
        });

    }
    GetCustomerListTessereAuth(username: string = "", rowIdCustomer: string = "",tokenid, usernameAuth) {
        return new Promise((resolve, reject) => {
            this._requestService.makeRequest('rest/internal/action/getCustomerListTessereAuth',
                {
                    "username": username,
                    "rowIdCustomer": rowIdCustomer
                    ,"tokenid": tokenid, "usernameAuth": usernameAuth
                },
                (data: IResponseGetCustomerListTessere) => {
                    resolve(data.listTessere);
                }, (error) => {
                    reject({ type: "SERVER", content: error.statusText })
                },
                null,
                false,
                null)
        });

    }

    GetCustomerListTessere(username: string = "", rowIdCustomer: string = "",key) {
        return new Promise((resolve, reject) => {
            this._requestService.makeRequest('rest/internal/action/getCustomerListTessereSecKey',
                {
                    "username": username,
                    "rowIdCustomer": rowIdCustomer,
                    "key":key
                },
                (data: IResponseGetCustomerListTessere) => {
                    resolve(data.listTessere);
                }, (error) => {
                    reject({ type: "SERVER", content: error.statusText })
                },
                null,
                false,
                null)
        });

    }

}


// WEBPACK FOOTER //
// ./src/app/theme/services/card.service.ts